import { render } from "./SurveyFormFeedback.vue?vue&type=template&id=121e660c&scoped=true"
import script from "./SurveyFormFeedback.vue?vue&type=script&lang=js"
export * from "./SurveyFormFeedback.vue?vue&type=script&lang=js"

import "./SurveyFormFeedback.vue?vue&type=style&index=0&id=121e660c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-121e660c"]])

export default __exports__